const frRuntimeTranslations: Record<string, string> = {
  'Dashboard': 'Tableau de bord',
  'Club': 'Club',
  'Leaderboard': 'Classement',
  'Members': 'Membres',
  'Queue & Courts': 'File et Terrains',
  'Evaluations': 'Evaluations',
  'Equipment': 'Equipement',
  'Match History': 'Historique des matchs',
  'Daily Match Report': 'Rapport quotidien',
  'Profile': 'Profil',
  'Theme & App': 'Theme et application',
  'Settings': 'Parametres',
  'Packages': 'Forfaits',
  'Rank': 'Rang',
  'Player': 'Joueur',
  'Rating': 'Note',
  'Games': 'Matchs',
  'Points': 'Points',
  'Point Difference (PD)': 'Difference de points (PD)',
  'Won': 'Gagnes',
  'Lost': 'Perdus',
  'Scored': 'Marques',
  'Against': 'Contre',
  'Showing': 'Affichage',
  'total': 'total',
  'Page': 'Page',
  'Prev': 'Prec',
  'Next': 'Suiv',
  'Manage your club members': 'Gerez les membres de votre club',
  'Manage your club members (': 'Gerez les membres de votre club (',
  'Import Members CSV': 'Importer un CSV de membres',
  'Upload CSV with headers: firstname, lastname, email.': 'Televersez un CSV avec les en-tetes : firstname, lastname, email.',
  'Role': 'Role',
  'Roles': 'Roles',
  'CSV File': 'Fichier CSV',
  'Choose CSV': 'Choisir CSV',
  'No file selected': 'Aucun fichier selectionne',
  'Remaining member slots:': 'Places membres restantes :',
  'Selected:': 'Selectionne :',
  'CSV rows:': 'Lignes CSV :',
  'First Name': 'Prenom',
  'Last Name': 'Nom de famille',
  'Available': 'Disponible',
  'Select': 'Choix',
  'Name': 'Nom',
  'Email': 'E-mail',
  'Upload a CSV to preview members.': 'Televersez un CSV pour previsualiser les membres.',
  'Reset': 'Reinitialiser',
  'Import Selected': 'Importer la selection',
  'Choose Your Avatar': 'Choisir votre avatar',
  'Selected': 'Selectionne',
  'None': 'Aucun',
  'Notes': 'Notes',
  'Difference de points (PD)': 'Difference de points (PD)',
  'Need 4 more players in queue': 'Il faut encore 4 joueurs dans la file',
  'No players in queue': 'Aucun joueur dans la file',
  'No players match your search.': 'Aucun joueur ne correspond a votre recherche.',
  'No prior head to head': 'Aucun historique face a face',
  'Shuffle': 'Melanger',
  'Clear': 'Effacer',
  'Admin': 'Admin',
  'Candidate': 'Candidat',
  'time in queue': 'temps dans la file',
  'Time Elapsed:': 'Temps ecoule :',
  'Assigned by:': 'Assigne par :',
  'Selection Criteria:': 'Critere de selection :',
  'Selection Criteria: Not set': 'Critere de selection : Non defini',
  'Finish Match': 'Terminer le match',
  'Finish Match - Court': 'Terminer le match - Terrain',
  'Finish': 'Terminer',
  'Enter the final score and any match notes.': 'Entrez le score final et des notes de match.',
  'Team 1': 'Equipe 1',
  'Team 2': 'Equipe 2',
  'Final score cannot be a tie.': 'Le score final ne peut pas etre une egalite.',
  'Equipment Used (Optional)': 'Equipement utilise (optionnel)',
  'Shoes': 'Chaussures',
  'Select shoes...': 'Selectionner des chaussures...',
  'Racket': 'Raquette',
  'Select racket...': 'Selectionner une raquette...',
  'Notes (Optional)': 'Notes (optionnel)',
  'Any notes about the match...': 'Notes sur le match...',
  'Evaluate players and admins': 'Evaluez les joueurs et les admins',
  'All ratings': 'Toutes les notes',
  'Filter rating': 'Filtrer la note',
  'Not evaluated': 'Non evalue',
  '4 stars': '4 etoiles',
  '3 stars': '3 etoiles',
  '2 stars': '2 etoiles',
  '1 star': '1 etoile',
  'Rate each category and add a quarter plan for this player.': 'Notez chaque categorie et ajoutez un plan trimestriel pour ce joueur.',
  'New Evaluation': 'Nouvelle evaluation',
  'Category Ratings (1-5)': 'Notes de categorie (1-5)',
  'Quarter Plan': 'Plan trimestriel',
  'Plan to improve over the next quarter...': 'Plan pour progresser au cours du prochain trimestre...',
  'Cancel': 'Annuler',
  'Delete': 'Supprimer',
  'Collapse': 'Reduire',
  'Last 3': '3 derniers',
  'Last 10': '10 derniers',
  'View all': 'Voir tout',
  'My Equipment': 'Mon equipement',
  'Manage your badminton gear': 'Gerez votre equipement de badminton',
  'No shoes added yet': 'Aucune chaussure ajoutee',
  'No rackets added yet': 'Aucune raquette ajoutee',
  'Type': 'Type',
  'Manufacturer *': 'Fabricant *',
  'Other': 'Autre',
  'Enter manufacturer': 'Entrer le fabricant',
  'Make/Model *': 'Marque/Modele *',
  'View all completed matches': 'Voir tous les matchs termines',
  'All dates': 'Toutes les dates',
  'Finished': 'Termine',
  'Assigned by': 'Assigne par',
  'Finished by': 'Termine par',
  'Winner': 'Vainqueur',
  'Started': 'Debut',
  'Debuted': 'Debut',
  'Endished': 'Termine',
  'Only matches that started and finished on the selected date.': 'Seulement les matchs commences et termines a la date selectionnee.',
  'Total Matches': 'Matchs totaux',
  'Players Played': 'Joueurs ayant joue',
  'Avg Matches / Player': 'Moy. matchs / joueur',
  'Matches by Selection': 'Matchs par selection',
  'No matches': 'Aucun match',
  'Player Summary': 'Resume joueur',
  'Unique opponents can be higher than total matches (each match has two opponents).': 'Le nombre d adversaires uniques peut etre superieur au total des matchs (chaque match a deux adversaires).',
  'Unique Opponents': 'Adversaires uniques',
  'Unique Partners': 'Partenaires uniques',
  'No matches played on this date.': 'Aucun match joue a cette date.',
  'Opponents Matrix': 'Matrice des adversaires',
  'ALL': 'TOUS',
  'Hide': 'Masquer',
  'No matches to show.': 'Aucun match a afficher.',
  'My Profile': 'Mon profil',
  'View and edit your profile information': 'Voir et modifier les informations de votre profil',
  'Not rated': 'Non note',
  'Profile Avatar': 'Avatar de profil',
  'Avatar feature is available on Elite (Package 3)': 'La fonction avatar est disponible sur Elite (Package 3)',
  'Upgrade to Package 3 to use and manage profile avatars.': 'Passez au Package 3 pour utiliser et gerer les avatars de profil.',
  'Personal Information': 'Informations personnelles',
  'Policy Consent': 'Consentement aux politiques',
  'I agree to the Privacy Policy.': "J'accepte la politique de confidentialite.",
  'I agree to the Terms and Conditions.': "J'accepte les conditions generales.",
  'I agree to the': "J'accepte la",
  'Privacy Policy': 'Politique de confidentialite',
  'Terms and Conditions': 'Conditions generales',
  'No evaluations yet': 'Aucune evaluation pour le moment',
  'Awaiting coach evaluation': "En attente de l'evaluation du coach",
  'Choose an avatar to represent you in the club. This will be visible to coaches and other members.': 'Choisissez un avatar pour vous representer dans le club. Il sera visible par les coachs et les autres membres.',
  'search members': 'rechercher des membres',
  'Search members': 'Rechercher des membres',
  'Search members...': 'Rechercher des membres...',
  'Search Members...': 'Rechercher des membres...',
  'All roles': 'Tous les roles',
  'Add New Member': 'Ajouter un nouveau membre',
  'Edit Member': 'Modifier le membre',
  'Cancel Edit': 'Annuler la modification',
  'Create Club': 'Creer un club',
  'Create your club to get started': 'Creez votre club pour commencer',
  'Search by player name': 'Rechercher par nom de joueur',
  'Add member': 'Ajouter un membre',
  'Add members': 'Ajouter des membres',
  'New member': 'Nouveau membre',
  'Upload complete': 'Televersement termine',
  'Import selected members': 'Importer les membres selectionnes',
  'Club Information': 'Informations du club',
  'View your club details': 'Voir les details de votre club',
  'Rackets': 'Raquettes',
  'Upload': 'Televerser',
  'Import': 'Importer',
  'Need': 'Il faut',
  'Security': 'Securite',
  'Save': 'Enregistrer',
  'Welcome back,': 'Bon retour,',
  'AI Coaching Insights': 'Insights de coaching IA',
  'your ai insights timeline': 'votre chronologie des insights IA',
  'Explore multiple AI-powered insights each week for a complete performance perspective.': 'Explorez plusieurs insights IA chaque semaine pour une vue complete de votre performance.',
  'Elite Plan': 'Forfait Elite',
  'Weekly Insights': 'Insights hebdomadaires',
  'insights in this week': 'insights cette semaine',
  'No previous week insights yet.': "Aucun insight des semaines precedentes pour le moment.",
  'Win Rate': 'Taux de victoire',
  'Matches': 'Matchs',
  'Court Time': 'Temps de terrain',
  'Coaching Takeaways': 'Points cles de coaching',
  'Insight #': 'Insight #',
  'Visible': 'Visible',
  'Total Members': 'Total des membres',
  'Total Membres': 'Total des membres',
  'Active Matches': 'Matchs actifs',
  'No active matches right now.': 'Aucun match actif pour le moment.',
  'Club Statistics': 'Statistiques du club',
  'Played Today': "Joues aujourd'hui",
  'Matches In Progress': 'Matchs en cours',
  'Matchs In Progress': 'Matchs en cours',
  'Avg Active Courts / Day': 'Moy. terrains actifs / jour',
  'Club Matches': 'Matchs du club',
  'Completed matches in selected club': 'Matchs termines dans le club selectionne',
  'Avg Matches per Court / Day': 'Moy. matchs par terrain / jour',
  'Completed matches divided by courts across active match days': 'Matchs termines divises par terrains sur les jours actifs',
  'From club queue sessions': 'Depuis les sessions de file du club',
  'Avg Match Duration': 'Duree moyenne du match',
  'Average duration of completed club matches': 'Duree moyenne des matchs termines du club',
  'Personalized Statistics for': 'Statistiques personnalisees pour',
  'Total Matches Played Till-Date': 'Total des matchs joues a ce jour',
  'Max Matches Won on a Day': 'Maximum de matchs gagnes sur une journee',
  'Max Matches Lost on a Day': 'Maximum de matchs perdus sur une journee',
  'Points Scored per Match': 'Points marques par match',
  'Net Points per Match': 'Points nets par match',
  'Wins & Losses by Day': 'Victoires et defaites par jour',
  'Points Scored vs Points Lost by Day': 'Points marques vs points perdus par jour',
  'Evaluation Progress Over Time': "Progression de l'evaluation dans le temps",
  'Waiting for evaluations.': "En attente d'evaluations.",
  'My Evaluation Profile': "Mon profil d'evaluation",
  'Evaluation data is not available yet.': "Les donnees d'evaluation ne sont pas encore disponibles.",
  'Queue Wait Time Distribution': "Repartition du temps d'attente",
  'Visual unavailable': 'Visuel indisponible',
  'Available in Pro and Elite': 'Disponible dans Pro et Elite',
  'Leaderboard Rank (Last 30 Days)': 'Rang au classement (30 derniers jours)',
  'Club Matches by Selection Mode (Last 30 Days)': 'Matchs du club par mode de selection (30 derniers jours)',
  'Court Usage by Day of Week': 'Utilisation des terrains par jour de semaine',
  'Court': 'Terrain',
  'Mon': 'Lun',
  'Tue': 'Mar',
  'Wed': 'Mer',
  'Thu': 'Jeu',
  'Fri': 'Ven',
  'Sat': 'Sam',
  'Sun': 'Dim',
  '7d Avg': 'Moy 7j',
  '14d': '14j',
  '30d': '30j',
  '90d': '90j',
  '365d': '365j',
  '7d': '7j',
  'Joueurs Played': 'Joueurs ayant joue',
  'Avg Matches / Joueur': 'Moy. matchs / joueur',
  'My Profil': 'Mon profil',
  'Profil Avatar': 'Avatar de profil',
  'Equipement': 'Equipement',
  'Ajouter': 'Ajouter',
  'Club Settings': 'Parametres du club',
  'Edit your club details and settings': 'Modifiez les details et parametres de votre club',
  'Basic Information': 'Informations de base',
  'Club Logo': 'Logo du club',
  'Click to upload an image': 'Cliquez pour televerser une image',
  'Club Name *': 'Nom du club *',
  'Which sport does your club play? *': 'Quel sport votre club pratique-t-il ? *',
  'Select sport': 'Selectionner un sport',
  'Slogan': 'Slogan',
  'Address': 'Adresse',
  'Play Schedule': 'Planning de jeu',
  'Configure your weekly play schedule': 'Configurez votre planning hebdomadaire de jeu',
  'Play Days': 'Jours de jeu',
  'Monday': 'Lundi',
  'Tuesday': 'Mardi',
  'Wednesday': 'Mercredi',
  'Thursday': 'Jeudi',
  'Friday': 'Vendredi',
  'Saturday': 'Samedi',
  'Sunday': 'Dimanche',
  'Default Play Time': 'Horaire par defaut',
  'Scheduled Play Times': 'Horaires planifies',
  'Day': 'Jour',
  'Start': 'Debut',
  'End': 'Fin',
  'Add': 'Ajouter',
  'Capacity Settings': 'Parametres de capacite',
  'Approximate Players': 'Nombre approximatif de joueurs',
  'Number of Courts': 'Nombre de terrains',
  'Player Selection Mode': 'Mode de selection des joueurs',
  'How players are assigned to courts': 'Comment les joueurs sont assignes aux terrains',
  'Round Robin': 'Round Robin',
  'Randomly picks 4 of the top 6, balances them into teams, and guarantees the remaining 2 are chosen next.': 'Selectionne aleatoirement 4 parmi les 6 premiers, equilibre les equipes et garantit que les 2 restants seront choisis ensuite.',
  'Skill Based': 'Base sur le niveau',
  'Balanced Teams': 'Equipes equilibrees',
  'Players Pick': 'Choix des joueurs',
  'Top queue player picks 3 teammates for the earliest free court; admin/coach can assist.': 'Le premier joueur de la file choisit 3 coequipiers pour le premier terrain libre; admin/coach peut aider.',
  'Queue & Court Controls': 'Controles file et terrains',
  'Enable or disable drag swap and queue shuffle': 'Activer ou desactiver le swap par glisser et le melange de la file',
  'Allow Swap of players once assigned to a court': "Autoriser l'echange des joueurs une fois assignes a un terrain",
  'Allow suffle of the queue (Please Note it will reset wait time in queue and shuffle players position in queue)': "Autoriser le melange de la file (veuillez noter que cela reinitialisera le temps d'attente dans la file et melangera la position des joueurs dans la file)",
  'Allow suffle of the queue (Please Note it will reset wait temps dans la file and shuffle players position in queue)': "Autoriser le melange de la file (veuillez noter que cela reinitialisera le temps d'attente dans la file et melangera la position des joueurs dans la file)",
  'Enabled': 'Active',
  'Disabled': 'Desactive',
  'Billing & Subscription': 'Facturation et abonnement',
  'Manage your Stripe subscription, invoices, and payment method securely.': 'Gerez votre abonnement Stripe, vos factures et votre moyen de paiement en toute securite.',
  'Current status': 'Statut actuel',
  'Current plan': 'Forfait actuel',
  'Start / Update Checkout': 'Demarrer / Mettre a jour le paiement',
  'Manage Billing': 'Gerer la facturation',
  'Recent invoices': 'Factures recentes',
  'paid': 'paye',
  'active': 'actif',
  'monthly': 'mensuel',
  'Save Changes': 'Enregistrer les modifications',
  "Here's what's happening at your club.": "Voici ce qui se passe dans votre club.",
  '3 insights in this week': '3 insights cette semaine',
  'Unlock weekly AI insights': 'Debloquez les insights IA hebdomadaires',
  'unlock weekly ai insights': 'debloquez les insights IA hebdomadaires',
  'Upgrade your plan to unlock complete AI-driven performance insights.': 'Mettez a niveau votre forfait pour debloquer des insights de performance complets bases sur l IA.',
  'Starter Plan': 'Forfait Starter',
  'Upgrade to unlock': 'Passez a niveau pour debloquer',
  'First AI Insight': 'Premier insight IA',
  'Generate your first weekly coaching summary.': 'Generez votre premier resume de coaching hebdomadaire.',
  'your weekly ai insight': 'votre insight IA hebdomadaire',
  'Get a concise weekly AI insight designed to highlight your key performance trends.': 'Obtenez un insight IA hebdomadaire concis concu pour mettre en avant vos principales tendances de performance.',
  'Your insight will use real match stats, court activity, ranking movement, evaluations, and equipment usage to produce a short coaching takeaway.': 'Votre insight utilisera les vraies statistiques de match, l activite sur les terrains, l evolution du classement, les evaluations et l utilisation de l equipement pour produire un court conseil de coaching.',
  'Upgrade to view insights': 'Passez a niveau pour voir les insights',
  'View Package Details': 'Voir les details des forfaits',
  'Upgrade Package': 'Mettre a niveau le forfait',
  'View your category-wise skill profile and identify strengths and improvement areas.': 'Consultez votre profil de competences par categorie et identifiez vos points forts et vos axes d amelioration.',
  'Club logo is an Elite feature': 'Le logo du club est une fonctionnalite Elite',
  'Upgrade to Package 3 (Elite) to upload and manage your club logo.': 'Passez au Forfait 3 (Elite) pour televerser et gerer le logo de votre club.',
  'This feature is available on Elite (Package 3) only.': 'Cette fonctionnalite est disponible uniquement sur Elite (Forfait 3).',
  'This feature is available on Elite (الباقة 3) only.': 'Cette fonctionnalite est disponible uniquement sur Elite (Forfait 3).',
  'You can change the package from Club settings': 'Vous pouvez changer le forfait depuis les parametres du club.',
  'Evaluations are unavailable on Starter (Package 1)': 'Les evaluations ne sont pas disponibles sur Starter (Forfait 1)',
  'Evaluations are unavailable on Starter (الباقة 1)': 'Les evaluations ne sont pas disponibles sur Starter (Forfait 1)',
  'Choose your package': 'Choisissez votre forfait',
  'All packages (monthly and yearly) include a 14-day free trial.': 'Tous les forfaits (mensuels et annuels) incluent un essai gratuit de 14 jours.',
  'Cancel anytime before the 14-day trial ends to avoid charges.': 'Annulez a tout moment avant la fin de l essai de 14 jours pour eviter toute facturation.',
  'Starter Package': 'Forfait Starter',
  '14-day free trial (monthly & yearly)': 'Essai gratuit de 14 jours (mensuel et annuel)',
  'Up to 50 active members': 'Jusqu a 50 membres actifs',
  'Member management': 'Gestion des membres',
  'Queue and court assignment': 'File d attente et affectation des terrains',
  'Match history and basic leaderboard': 'Historique des matchs et classement de base',
  'Basic admin dashboard': 'Tableau de bord admin de base',
  'Everything in Starter': 'Tout ce qui est inclus dans Starter',
  'Up to 150 active members': 'Jusqu a 150 membres actifs',
  'Coach evaluations': 'Evaluations des coachs',
  'Equipment tracking': "Suivi de l'equipement",
  'Limited ML-assisted analytics for key performance trends': 'Analyses limitees assistees par ML pour les tendances cles de performance',
  'Actionable performance insights on your dashboard to help members improve faster.': 'Des insights de performance actionnables sur votre tableau de bord pour aider les membres a progresser plus vite.',
  'Daily match reports and advanced leaderboard trends': 'Rapports de match quotidiens et tendances avancees du classement',
  'Everything in Pro': 'Tout ce qui est inclus dans Pro',
  'Up to 250 active members': 'Jusqu a 250 membres actifs',
  'Advanced roles and permissions, including multiple club admins': 'Roles et permissions avances, y compris plusieurs admins de club',
  "Advanced UI controls to customize your app's colors and fonts for your club brand.": "Controles UI avances pour personnaliser les couleurs et polices de votre application selon l image de votre club.",
  'Upload and manage your club logo for branded club pages.': 'Televersez et gerez le logo de votre club pour des pages de club a votre image.',
  'Members can choose profile avatars for a more personalized experience.': 'Les membres peuvent choisir des avatars de profil pour une experience plus personnalisee.',
  'Chat with AI to uncover hidden patterns and insights from your match history': 'Discutez avec l IA pour decouvrir des tendances cachees et des insights a partir de votre historique de matchs',
  'Subscribe yearly Plan': 'Souscrire au forfait annuel',
  'Yearly plans also include a 14-day free trial. Cancel anytime before trial ends.': 'Les forfaits annuels incluent egalement un essai gratuit de 14 jours. Annulez a tout moment avant la fin de l essai.',
  'Monthly total:': 'Total mensuel :',
  'Welcome back!': 'Bon retour !',
  'Assign Players': 'Assigner les joueurs',
  'Evaluate': 'Evaluer',
  '1 star': '1 etoile',
  '2 stars': '2 etoiles',
  'No players to evaluate. Add players first!': "Aucun joueur a evaluer. Ajoutez d'abord des joueurs !",
  'You can change the package from Club settings.': 'Vous pouvez changer le forfait depuis les parametres du club.',
  'You can change the package from النادي settings': 'Vous pouvez changer le forfait depuis les parametres du club.',
  'Remove from queue?': 'Retirer de la file ?',
  'You are about to remove': 'Vous etes sur le point de retirer',
  'from the queue. Are you sure?': 'de la file. Etes-vous sur ?',
  'Remove from court?': 'Retirer du terrain ?',
  'from the court. They will be placed at the end of the queue. Continue?': 'du terrain. Il sera place a la fin de la file. Continuer ?',
  'Remove': 'Retirer',
  'Removing...': 'Retrait...',
  'Finishing...': 'Finalisation...',
  'Queue': 'File',
  'Add to Queue': 'Ajouter a la file',
  'Enabled (Email OTP required on login)': 'Active (OTP par e-mail requis a la connexion)',
  'Disabled': 'Desactive',
  'Time in Queue:': "Temps dans la file d'attente :",
  'Avg time in queue': "Temps moyen dans la file",
  'Logo is locked until you edit the club': "Le logo est verrouille jusqu'a ce que vous modifiiez le club",
  'This feature is available on Elite (الباقة 3) only.': 'Cette fonctionnalite est disponible uniquement sur Elite (Forfait 3).',
  'Evaluations are unavailable on Starter (الباقة 1)': 'Les evaluations ne sont pas disponibles sur Starter (Forfait 1)',
  'You can change the package from النادي settings': 'Vous pouvez changer le forfait depuis les parametres du club.',
  'This will randomize the current queue order. Are you sure you want to shuffle the queue?': 'Cela melangera l ordre actuel de la file. Voulez-vous vraiment melanger la file ?',
  'This will remove all queued players. Are you sure you want to reset the queue?': 'Cela supprimera tous les joueurs de la file. Voulez-vous vraiment reinitialiser la file ?',
  'Yes, continue': 'Oui, continuer',
  'Generate weekly insight': 'Generer une insight hebdomadaire',
  'Already generated this week': 'Deja genere cette semaine',
  'Enable 2FA for login (email OTP will be required every time).':
    "Activer la 2FA pour la connexion (un OTP par e-mail sera requis a chaque fois).",
  'Failed to load billing snapshot': 'Echec du chargement de l apercu de facturation',
  'Failed to load policies': 'Echec du chargement des politiques',
  'Failed to load failed payments': 'Echec du chargement des paiements echoues',
  'Policy title is required': 'Le titre de la politique est requis',
  'Draft saved': 'Brouillon enregistre',
  'Could not save draft': 'Impossible d enregistrer le brouillon',
  'Version is required': 'La version est requise',
  'Policy published': 'Politique publiee',
  'Could not publish policy': 'Impossible de publier la politique',
  'Account created, but billing checkout could not be started.':
    "Le compte a ete cree, mais le paiement n'a pas pu etre demarre.",
  'Enter your email to receive a reset link': 'Entrez votre e-mail pour recevoir un lien de reinitialisation',
  'If the email exists, a reset link has been sent':
    'Si l e-mail existe, un lien de reinitialisation a ete envoye',
  'Could not send reset link': 'Impossible d envoyer le lien de reinitialisation',
  'Players assigned to court': 'Joueurs assignes au terrain',
  'Queue is at capacity for this club': 'La file est complete pour ce club',
  'Players can only add themselves to the queue':
    'Les joueurs peuvent seulement s ajouter eux-memes a la file',
  'Players can only remove themselves from the queue':
    'Les joueurs peuvent seulement se retirer eux-memes de la file',
  'Failed to remove player from court': 'Impossible de retirer le joueur du terrain',
  'Court IDs are not available yet. Please refresh or update courts in Club Settings.':
    'Les identifiants des terrains ne sont pas encore disponibles. Actualisez ou mettez a jour les terrains dans les parametres du club.',
  'Finish the current match on this court before assigning new players':
    'Terminez le match en cours sur ce terrain avant d assigner de nouveaux joueurs',
  'Need at least 4 players in queue': 'Il faut au moins 4 joueurs dans la file',
  'Already assigning players to this court...': 'Affectation des joueurs a ce terrain deja en cours...',
  'Players assigned to court!': 'Joueurs assignes au terrain !',
  'Players swapped': 'Joueurs echanges',
  'Queue cleared': 'File videe',
  'Queue shuffle is disabled for this club': 'Le melange de la file est desactive pour ce club',
  'Queue shuffled': 'File melangee',
  'Top player skipped': 'Premier joueur saute',
  'Only players on this court or coaches/admins can finish the match':
    'Seuls les joueurs de ce terrain ou les coachs/admins peuvent terminer le match',
  'You are not allowed to finish this match': 'Vous n etes pas autorise a terminer ce match',
  'Match finished and queue updated': 'Match termine et file mise a jour',
  'Profile updated!': 'Profil mis a jour !',
  'Failed to update profile': 'Echec de la mise a jour du profil',
  'Avatar feature is available on Elite (Package 3) only.':
    'La fonctionnalite avatar est disponible uniquement sur Elite (Forfait 3).',
  'Avatar metadata not found': 'Metadonnees de l avatar introuvables',
  'Avatar saved!': 'Avatar enregistre !',
  'Failed to save avatar': 'Echec de l enregistrement de l avatar',
  'Select a club first.': 'Selectionnez d abord un club.',
  'Select a club first': 'Selectionnez d abord un club',
  'Selected role is not available in this package.':
    "Le role selectionne n'est pas disponible dans ce forfait.",
  'Failed to import CSV file': 'Echec de l import du fichier CSV',
  'Please fill in required fields': 'Veuillez remplir les champs obligatoires',
  'Member added successfully!': 'Membre ajoute avec succes !',
  'Failed to add member': 'Echec de l ajout du membre',
  'Member updated!': 'Membre mis a jour !',
  'Failed to update member': 'Echec de la mise a jour du membre',
  'Member removed': 'Membre retire',
  'Cannot delete member while they are queued or playing':
    'Impossible de supprimer le membre pendant qu il est dans la file ou en train de jouer',
  'Coach role is not available in this package.':
    "Le role de coach n'est pas disponible dans ce forfait.",
  'Select at least one member to import.': 'Selectionnez au moins un membre a importer.',
  'Selected rows must include first name, last name, and email.':
    'Les lignes selectionnees doivent inclure le prenom, le nom et l e-mail.',
  'Active members updated to match your package limit.':
    'Les membres actifs ont ete mis a jour pour correspondre a la limite de votre forfait.',
  'Failed to apply member limit selection':
    'Echec de l application de la selection de limite des membres',
  'Match finished': 'Match termine',
  'Evaluation updated!': 'Evaluation mise a jour !',
  'Evaluation added!': 'Evaluation ajoutee !',
  'Failed to save evaluation': "Echec de l'enregistrement de l'evaluation",
  'Evaluation deleted': 'Evaluation supprimee',
  'Failed to delete evaluation': "Echec de la suppression de l'evaluation",
  'Equipment added!': 'Equipement ajoute !',
  'Failed to add equipment': "Echec de l'ajout de l'equipement",
  'Equipment updated!': 'Equipement mis a jour !',
  'Failed to update equipment': "Echec de la mise a jour de l'equipement",
  'Equipment deleted': 'Equipement supprime',
  'Failed to delete equipment': "Echec de la suppression de l'equipement",
  'Failed to load goals': 'Echec du chargement des objectifs',
  'Evaluations refreshed': 'Evaluations actualisees',
  'Failed to refresh evaluations': 'Echec de l actualisation des evaluations',
  'Goal updated': 'Objectif mis a jour',
  'Could not update goal': 'Impossible de mettre a jour l objectif',
  'Failed to delete': 'Echec de la suppression',
  'Club logo is available on Elite (Package 3). Please upgrade your package.':
    'Le logo du club est disponible sur Elite (Forfait 3). Veuillez mettre a niveau votre forfait.',
  'Logo file is too large (max 2MB)': 'Le fichier du logo est trop volumineux (max 2 Mo)',
  'Logo uploaded': 'Logo televerse',
  'Failed to upload logo': 'Echec du televersement du logo',
  'Please fill in all play time fields': 'Veuillez remplir tous les champs d horaire de jeu',
  'Club name is required': 'Le nom du club est requis',
  'Sport type is required': 'Le type de sport est requis',
  'Add at least one scheduled play time': 'Ajoutez au moins un horaire de jeu programme',
  'You do not have permission to update the club':
    "Vous n'avez pas l'autorisation de mettre a jour le club",
  'Club updated successfully!': 'Club mis a jour avec succes !',
  'Club created successfully!': 'Club cree avec succes !',
  'Could not start checkout': 'Impossible de demarrer le paiement',
  'Could not open billing portal': 'Impossible d ouvrir le portail de facturation',
  'Subscription cancellation scheduled for period end.':
    "L'annulation de l'abonnement est planifiee pour la fin de la periode.",
  'Could not cancel subscription': "Impossible d'annuler l'abonnement",
  'No active club selected': 'Aucun club actif selectionne',
  'Club updated': 'Club mis a jour',
  'Could not update club': 'Impossible de mettre a jour le club',
  'You were logged out due to inactivity.': 'Vous avez ete deconnecte en raison de l inactivite.',
  'Your weekly insight is ready.': 'Votre insight hebdomadaire est pret.',
  'Unable to generate an insight right now.': 'Impossible de generer un insight pour le moment.',
  'These email(s) are already exist. Remove those from selection, then continue import.':
    'Ces e-mails existent deja. Retirez-les de la selection, puis poursuivez l import.',
  'These email(s) are already exist.': 'Ces e-mails existent deja.',
  'Remove those from selection, then continue import.':
    'Retirez-les de la selection, puis poursuivez l import.',
  'We sent a reset link to': 'Nous avons envoye un lien de reinitialisation a',
  'The link expires shortly, so use it soon.':
    'Le lien expire bientot, utilisez-le rapidement.',
  'Cannot deactivate while member is queued or playing':
    'Impossible de desactiver un membre lorsqu il est dans la file ou en train de jouer',
  'Cannot deactivate while عضو is queued or playing':
    'Impossible de desactiver un membre lorsqu il est dans la file ou en train de jouer',
  'match already finished': 'match deja termine',
  'player': 'joueur',
  'players': 'joueurs',
  'Player': 'Joueur',
  'Players': 'Joueurs',
  'coach': 'entraineur',
  'coaches': 'entraineurs',
  'Coach': 'Entraineur',
  'Coaches': 'Entraineurs',
  'admin': 'administrateur',
  'admins': 'administrateurs',
  'Admin': 'Administrateur',
  'Admins': 'Administrateurs',
  'Nickname': 'Surnom',
  'Update member information.': 'Mettre a jour les informations du membre.',
  'Update عضو information.': 'Mettre a jour les informations du membre.',
  'Active': 'Actif',
  'active': 'actif',
  'Inactive': 'Inactif',
  'Member activated': 'Membre active',
  'Member deactivated': 'Membre desactive',
  'Delete this evaluation? This cannot be undone.':
    'Supprimer cette evaluation ? Cette action est irreversible.',
  'Are you sure you want to delete this equipment?':
    'Voulez-vous vraiment supprimer cet equipement ?',
  'Edit Equipment': "Modifier l'equipement",
  'Type': 'Type',
  'Shoes': 'Chaussures',
  'Racket': 'Raquette',
  'Manufacturer *': 'Fabricant *',
  'Make/Model *': 'Marque/Modele *',
};

export default frRuntimeTranslations;
